import { render, staticRenderFns } from "./DealFormHeader.vue?vue&type=template&id=0609fb6c&scoped=true&"
import script from "./DealFormHeader.vue?vue&type=script&lang=js&"
export * from "./DealFormHeader.vue?vue&type=script&lang=js&"
import style0 from "./DealFormHeader.vue?vue&type=style&index=0&id=0609fb6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0609fb6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
